import { RouteComponentProps } from '@reach/router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import css from './StockEquipmentItem.module.scss';
import { StockEquipmentDetails } from './StockEquipmentDetails';
import { useEffects, useOvermindState } from '../../state';
import { StockEquipmentDocuments } from './StockEquipmentDocuments';
import { useAsyncData } from '../../hooks';
import { Spinner } from '../Spinner/Spinner';
import { StockEquipmentContact } from './StockEquipmentContact';
import { StockEquipmentPrice } from './StockEquipmentPrice';

export const StockEquipmentItem: React.FC<RouteComponentProps> = () => {
    const { t } = useTranslation('StockEquipment');
    const { selectedStockEquipment } = useOvermindState();
    const { api } = useEffects();

    const loadDocument = () => api.getDocuments(selectedStockEquipment?.documentKeys || []);
    const [documents, isDocumentsLoading] = useAsyncData(loadDocument, [], [selectedStockEquipment]);

    if (!selectedStockEquipment || selectedStockEquipment.id === null) {
        return <p className={css.myEquipmentItem}>{t('No equipment found')}</p>;
    }

    return selectedStockEquipment ? (
        <div className={css.myEquipmentItem} id={`my-equipment-item-${selectedStockEquipment.id}`}>
            <div className={css.columns}>
                <div className={css.column}>
                    <StockEquipmentDetails stockEquipment={selectedStockEquipment} />
                </div>
                <div className={css.column}>
                    {isDocumentsLoading ? <Spinner size={3} /> : <StockEquipmentDocuments documents={documents} />}
                </div>
                <div className={css.column}>
                    <StockEquipmentPrice stockEquipment={selectedStockEquipment} />
                    <StockEquipmentContact stockEquipment={selectedStockEquipment} />
                </div>
            </div>
        </div>
    ) : null;
};
